import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { HttpService } from '../../services/http.service';
import { ConstantsService } from '../../constants/constants.service';
import { Router, RouterLink } from '@angular/router';
import { CdkTableModule } from '@angular/cdk/table';
import { HttpClientModule } from '@angular/common/http';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

// import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatCardModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    CommonModule,
  ],
  styleUrls: ['./login.component.scss'],
  // providers: [AuthService],
  // schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LoginComponent {
  loginValid: boolean = true;
  username: string = '';
  password: string = '';
  hide: boolean = true;
  apiUrl!: string;

  constructor(
    private constants: ConstantsService,
    private router: Router,
    private httpService: HttpService
  ) {
    this.loadConfig();
  }

  private loadConfig() {
    // this.http.get<any>('assets/users.json').subscribe(config => {
    //   this.apiUrl = config.apiURL.localapi;
    // })
  }

  ngOnInit() {
    // sessionStorage.setItem('isLoggedIn', 'false');
  }

  login() {
    const userCredentials = {
      email: this.username,
      password: this.password,
    };

    this.httpService
      .postRequest(this.constants.SERVER_URLS['LOGIN'], userCredentials)
      .subscribe(
        (res: any) => {
          if (res.status === '200') {
            console.log('Loggedin');
            sessionStorage.setItem('currentUser', res.result); // Save token if needed
            this.router.navigate(['/home']);
            console.log('Loggedin2');
          } else {
            console.log('Lo');
            this.handleInvalidLogin();
          }
        },
        (error) => {
          this.handleInvalidLogin();
        }
      );
  }

  handleInvalidLogin() {
    sessionStorage.setItem('isLoggedIn', 'false');
    this.loginValid = false;
    this.hide = true;
    alert('Invalid credentials');
  }

  toggleHide() {
    this.hide = !this.hide;
  }
}